import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown } from 'ui';
import styled from 'styled-components';
import uniqBy from 'lodash.uniqby';
import sortBy from 'lodash.sortby';
import { injectIntl } from 'react-intl';
import { Select } from 'antd';

const StatusDropdown = styled(Dropdown)`
  .ant-select-selection__choice:not(.ant-select-selection__choice__disabled) {
    background-color: #bfe4f0;
  }

  &__dropdown {
    .ant-select-dropdown-menu-item {
      color: ${p => p.theme.colors.text};
    }
    .ant-select-dropdown-menu-item-selected:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: #bfe4f0;
    }
    .ant-select-dropdown-menu-item-disabled {
      color: #9b9b9b !important;
      &:after {
        color: #9b9b9b !important;
      }
    }
  }
`;

const UserStatusDropdown = ({
  disabled = false,
  value = [],
  onStatusesChanged,
  setFormDirty,
  activeStatus,
  userStatuses = [],
}) => {
  const getSelectedStatuses = (selectedKeys) => {
    if (setFormDirty) {
      setFormDirty();
    }
    return selectedKeys?.map((statusKey) => {
      const status = userStatuses?.find(s => s.id === statusKey);
      // if status is not in list/statuses, get it from the data object
      return status || value?.find(s => s.id === statusKey);
    });
  };

  const onChange = (ids) => {
    if (onStatusesChanged && userStatuses?.length) {
      onStatusesChanged(getSelectedStatuses(ids));
    }
  };

  const checkAvailability = (v) => {
    if (!v.canChange) {
      return false;
    }
    if (!v.orderActionFilter || !v.orderActionFilter.length) {
      return true;
    }
    return v.orderActionFilter?.find(o => o === activeStatus.label) || false;
  };

  const mergedStatuses = sortBy(uniqBy([...userStatuses, ...value], 'id'), [
    s => !s.canChange,
    'id',
  ]);

  const selectedKeys = value?.map(i => i.id);

  return (
    <>
      <StatusDropdown
        multiSelect
        showArrow={true}
        values={mergedStatuses}
        value={selectedKeys}
        optionLabelProp='title'
        disabled={disabled}
        onChange={onChange}
        renderOption={v =>
          <Select.Option
            value={v.id}
            key={v.id}
            disabled={!checkAvailability(v)}
            title={v.id}
          >
            {v.id} - {v.label}
          </Select.Option>
        }
      />
    </>
  );
};

UserStatusDropdown.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.array,
  onStatusesChanged: PropTypes.func,
  setFormDirty: PropTypes.func,
  activeStatus: PropTypes.object,
  userStatuses: PropTypes.array,
};

export default injectIntl(UserStatusDropdown, { forwardRef: true });
